<app-modal #modal>

  <span title>{{"Size List"|translate}}</span>

  <div body class="list-group">

    <div class="size-row header">
      <div>{{'SIZE'|translate}}</div>
      <div>{{'SAPCODE'|translate}}</div>
      <!-- <div>{{'STOCK'|translate}}</div> -->
    </div>

    @for (size of sizeList(); track $index) {
    <button class="btn size-row" [class.selected]="selectedSize()?.sapCode === size.sapCode"
       (click)="selectedSize.set(size)">
       <div>{{size.size}}</div>
       <div>{{size.sapCode}}</div>
      <!-- <div>{{size.centralStock}}</div> -->
    </button>
    }

  </div>

  <div footer class="footer">
    <button class="btn btn-primary" (click)="handleConfirm()" [disabled]="disabledConfirm()">
      {{"Select size"|translate}}&nbsp;{{selectedSize()?.size}}
    </button>
    <button class="btn btn-secondary" (click)="modal.dismiss()">
      {{"Close"|translate}}

    </button>
  </div>

</app-modal>
